import { Component, ChangeDetectionStrategy, signal, HostListener, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';
import { MatSidenavModule } from '@angular/material/sidenav';
import { GlobalHeaderComponent } from '../../../../shared/components/layout/global-header/global-header';
import { GlobalFooterComponent } from '../../../../shared/components/layout/global-footer/global-footer';
import { GlobalSidebarComponent } from '../../../../shared/components/layout/global-sidebar/global-sidebar';
import { SidebarItem } from '../../../../shared/components/layout/global-sidebar/sidebar.model';
import { routeChainHidesSidebar } from '../../../../shared/components/layout/global-sidebar/sidebar-utils';
import { BreadcrumbComponent } from '../../../../shared/components/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-grants-layout',
  standalone: true,
  imports: [
    GlobalHeaderComponent,
    GlobalFooterComponent,
    GlobalSidebarComponent,
    RouterOutlet,
    MatSidenavModule,
    BreadcrumbComponent],
  templateUrl: './grants-layout.component.html',
  styleUrl: './grants-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GrantsLayoutComponent {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  hideSidebar = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(() => routeChainHidesSidebar(this.activatedRoute.snapshot)),
      startWith(routeChainHidesSidebar(this.activatedRoute.snapshot)),
    ),
    { requireSync: true },
  );

  isMobile = signal(typeof window !== 'undefined' ? window.innerWidth <= 768 : false);

  @HostListener('window:resize')
  onResize() {
    if (typeof window !== 'undefined') {
      this.isMobile.set(window.innerWidth <= 768);
      if (this.isMobile()) this.sidenavOpened.set(false);
      else this.sidenavOpened.set(true);
    }
  }
  sidenavOpened = signal(typeof window !== 'undefined' ? window.innerWidth > 768 : true);

  menuConfig: SidebarItem[] = [
    { id: 'item_0', label: 'grants.sidebar.dashboard', icon: 'dashboard', route: '/grants' },
    { id: 'item_1', label: 'grants.sidebar.schemeRegister', icon: 'menu_book', route: '/grants/scheme-register' }
  ];



  toggleSidenav(): void {
    this.sidenavOpened.update(v => !v);
  }
}
